// extracted by mini-css-extract-plugin
module.exports = {"myServices":"MySevices_myServices__33sW1","title":"MySevices_title__rI202","blocks":"MySevices_blocks__2ExSn"};